import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>
              Carmanya Financial & Company Secretary Services. We are one of the largest 
              financial and company secretarial service providers. Building strong and substantial client 
              relationship is and will remain the compass for our business strategy and 
              future development.
            </p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/research">Research</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact Info</h3>
            <p>
              <strong>Head Office:</strong><br />
              201-206, Shiv Smriti, 2nd Floor,<br />
              49/A Dr. Annie Besant Road, Above Corporation Bank,<br />
              Worli, Mumbai – 400018.<br />
              Maharashtra, India
            </p>
            <p>
              <strong>Email:</strong> info@carmanya.com<br />
              <strong>Phone:</strong> +91 xxx
            </p>
          </div>
          <div className="footer-section">
            <h3>Working Hours</h3>
            <p>
              <strong>Monday - Friday:</strong><br />
              9:30 a.m. to 6:00 p.m.<br />
              Sunday & Public Holidays (Closed)
            </p>
            <div className="social-links">
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">Facebook</a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">LinkedIn</a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Twitter">Twitter</a>
              <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">Instagram</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Carmanya. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
